import React, { useState } from "react";
import Button from "components/Button";
import SQL from "components/SQL";
import SQLNew from "components/SQLNew";

import {
  faArrowsMaximize,
  faArrowsMinimize,
} from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { QueryScanToken } from "types/types";

const EXPAND_CUTOFF = 200;

type Props = {
  sql: string;
  databaseId?: string;
  scanTokens?: QueryScanToken[] | null;
};

const ExpandableSQL: React.FunctionComponent<Props> = ({
  sql,
  databaseId,
  scanTokens,
}) => {
  const threeNewlines = /(?:.*\n){3}/;
  const expandable = sql.length > EXPAND_CUTOFF || threeNewlines.test(sql);

  const [expanded, setExpanded] = useState(false);
  const handleExpand = (
    evt: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    evt.preventDefault();
    setExpanded((expanded) => !expanded);
  };

  let maybeTruncatedSql = sql;
  if (expandable && !expanded) {
    const truncated =
      sql.length > EXPAND_CUTOFF
        ? sql.substring(0, EXPAND_CUTOFF)
        : sql.match(threeNewlines)[0];

    maybeTruncatedSql = truncated + "...";
  }
  // We're intentionally covering the control character range, since this is
  // just used to determine which component to use, and the logic is simpler
  // that way. We don't expect control characters in the input, but passing
  // them through is fine.
  //
  // eslint-disable-next-line no-control-regex
  const hasMultibyteChars = /[^\u0000-\u007f]/.test(sql);

  return (
    <>
      {databaseId != null && scanTokens != null && !hasMultibyteChars ? (
        <SQLNew
          queryText={maybeTruncatedSql}
          databaseId={databaseId}
          scanTokens={scanTokens}
        />
      ) : (
        <SQL sql={maybeTruncatedSql} />
      )}
      {expandable && (
        <div className="pt-2">
          <Button onClick={handleExpand} variant="link" bare>
            <FontAwesomeIcon
              icon={expanded ? faArrowsMinimize : faArrowsMaximize}
            />{" "}
            {expanded ? "Hide" : "Show"} full query text
          </Button>
        </div>
      )}
    </>
  );
};

export default ExpandableSQL;
